import React from 'react';
import usePropertyPhotoDisplay from '../shared/usePropertyPhotoDisplay';

const PHOTO_ACCEPT = 'image/jpeg,image/jpg,image/png,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';

export function StoredPropertyPhoto({ stored, alt = '', style, fallback = null }) {
  const photo = usePropertyPhotoDisplay(stored);
  if (photo.missing) return fallback;
  if (!photo.src) return null;
  return <img src={photo.src} alt={alt} onError={photo.onError} style={style} />;
}

function PropertyPhoto({ url, editing, uploading, onFile, colors, brandColor, isMobile }) {
  const photo = usePropertyPhotoDisplay(url);
  const showImage = Boolean(photo.src);
  const placeholder = (
    <div
      role="img"
      aria-label="No property photo"
      style={{
        width: '100%',
        minHeight: '160px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '1.5rem',
        borderRadius: isMobile ? '1.25rem' : '0.5rem',
        background: (colors && colors.surfaceAlt) || '#f4f4f4',
        color: (colors && colors.textSecondary) || '#666',
        border: `1px solid ${(colors && colors.border) || '#e5e5e5'}`,
      }}
    >
      No property photo yet
    </div>
  );

  return (
    <div style={{ marginBottom: '1.5rem', minWidth: 0, maxWidth: '100%' }}>
      {showImage ? (
        <img
          src={photo.src}
          alt="Property"
          onError={photo.onError}
          style={{
            width: '100%',
            maxHeight: '300px',
            objectFit: 'cover',
            borderRadius: isMobile ? '1.25rem' : '0.5rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            display: 'block',
          }}
        />
      ) : photo.recovering ? (
        <div
          style={{
            width: '100%',
            minHeight: '160px',
            borderRadius: isMobile ? '1.25rem' : '0.5rem',
            background: (colors && colors.surfaceAlt) || '#f4f4f4',
          }}
        />
      ) : placeholder}
      {editing && (
        <label style={{ display: 'block', marginTop: '0.75rem', color: colors && colors.text, fontWeight: 600 }}>
          {url ? 'Change photo' : 'Add photo'} (JPG, PNG, or HEIC, up to 10 MB)
          <input
            type="file"
            accept={PHOTO_ACCEPT}
            onChange={onFile}
            disabled={uploading}
            style={{
              display: 'block',
              width: '100%',
              boxSizing: 'border-box',
              fontSize: '16px',
              background: colors && colors.surface,
              border: `2px solid ${brandColor || '#59c4c4'}`,
              color: colors && colors.text,
              padding: '0.75rem',
              marginTop: '0.35rem',
              borderRadius: '0.5rem',
            }}
          />
        </label>
      )}
      {uploading && (
        <p style={{ fontSize: '0.85rem', color: brandColor || '#59c4c4', marginTop: '0.5rem' }}>Uploading photo...</p>
      )}
    </div>
  );
}

export default PropertyPhoto;
